import type { TMessages } from '@/types/TMessages'

export const messages = {
  source: 'Источник: {source}',
  social: 'Поделиться',
} satisfies TMessages
